// сайдрбар и его функции

function sidebar() {
  const sidebarBtn = document.getElementById('sidebarBtn');
  const sidebar = document.getElementById('sidebar');
  const sidebarBurger = document.getElementById('burger--sidebar');

  sidebarBtn.addEventListener('click', function () {
    this.classList.toggle('true');

    if (this.classList.contains('true')) {
      sidebar.classList.add('true')
      sidebarBurger.classList.add('true')
    } else {
      sidebar.classList.remove('true')
      sidebarBurger.classList.remove('true')
    }
  })

  function remove () {
    sidebarBtn.classList.remove('true');
    sidebar.classList.remove('true');
    sidebarBurger.classList.remove('true');
  }

  document.addEventListener('click', (e) => {
    let click = e.composedPath().includes(sidebar);
    if (!click) {
      remove()
    } else {

    }
  })
}

function sidebarBtnCopy() {
  const sidebarBtn = document.getElementById('btn__copy');
  sidebarBtn.addEventListener('click', () =>  {
    let tempInput = document.createElement('textarea');

    tempInput.style.fontSize = '12pt';
    tempInput.style.border = '0';
    tempInput.style.padding = '0';
    tempInput.style.margin = '0';
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    tempInput.setAttribute('readonly', '');

    tempInput.value = window.location.href;

    sidebarBtn.parentNode.appendChild(tempInput);

    tempInput.select();
    tempInput.setSelectionRange(0, 99999);

    document.execCommand('copy');

    tempInput.parentNode.removeChild(tempInput);
  })
}

function sidebarBtnSocial() {


}


export {
  sidebar,
  sidebarBtnCopy,
  sidebarBtnSocial
}
